<template>
  <div class="row">
    <div class="col-lg-7">
      <div class="card shadow-sm border border-gray rounded mb-3 mb-lg-0">
        <div class="card-header bg-white border border-gray border-bottom py-3">
          <div
            class="d-flex flex-wrap align-items-center justify-content-between"
          >
            <div
              class="d-flex align-items-center border border-gray rounded p-2"
            >
              <div class="custom-control custom-switch">
                <input
                  v-model="accion_ruta"
                  type="checkbox"
                  id="accion_ruta"
                  class="custom-control-input"
                  @click="viewMap.nodos = false"
                />
                <label
                  class="custom-control-label font-weight-bold text-dark"
                  for="accion_ruta"
                >
                  <i class="fas fa-edit mr-1"></i> Editar Ruta
                </label>
              </div>
            </div>
            <div v-if="accion_ruta && markers.ruta.path.length > 1">
              <button @click="save()" type="button" class="btn btn-success">
                <i class="fas fa-paper-plane mr-1"></i> Guardar
              </button>
            </div>
          </div>
        </div>
        <!-- Visualización Mapa -->
        <div class="card-body p-0 overflow-hidden rounded-0">
          <gmap-map
            class="w-100"
            style="height: 500px"
            id="mapNodos"
            :center="viewMap.center"
            :zoom="viewMap.zoom"
            :options="{
              disableDefaultUI: true,
              zoomControl: true,
              mapTypeControl: true,
            }"
          >
            <!-- Marcador de origen -->
            <gmap-marker
              v-if="markers.inicio_ruta"
              :position="markers.inicio_ruta.position"
              :icon="url_docs + '/' + markers.inicio_ruta.icon"
            ></gmap-marker>
            <!-- Marcador de destino -->
            <gmap-marker
              v-if="markers.fin_ruta"
              :position="markers.fin_ruta.position"
              :icon="url_docs + '/' + markers.fin_ruta.icon"
            ></gmap-marker>
            <!-- Polilíneas de tramos de la ruta (cuando no está en modo edición) -->
            <gmap-polyline
              v-for="(tramoRuta, index) in tramosRutaConPath"
              :key="'tramo-ruta-' + tramoRuta.id + '-' + index"
              :options="{
                strokeColor: tramoRuta.color || '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
              :path="tramoRuta.path"
              @click="manejarClickTramo(tramoRuta, $event)"
            ></gmap-polyline>

            <!-- Polilíneas de tramos añadidos (cuando está en modo edición) -->
            <gmap-polyline
              v-for="(tramoAñadido, index) in tramosAñadidosConPathEdit"
              :key="'tramo-' + tramoAñadido.id + '-' + index"
              :options="{
                strokeColor: tramoAñadido.color || '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
              :path="tramoAñadido.path"
              @click="manejarClickTramo(tramoAñadido, $event)"
            ></gmap-polyline>

            <!-- Marcadores pequeños visibles en el punto medio de cada tramo de la ruta -->
            <gmap-marker
              v-for="(tramoRuta, index) in tramosRutaConPath"
              :key="'marker-tramo-ruta-' + tramoRuta.id + '-' + index"
              :position="obtenerPuntoMedioTramo(tramoRuta)"
              :icon="
                googleSymbolPath
                  ? {
                      path: googleSymbolPath.CIRCLE,
                      scale: 6,
                      fillColor: '#00529c',
                      fillOpacity: 0.6,
                      strokeColor: '#FFFFFF',
                      strokeWeight: 2,
                    }
                  : null
              "
              :zIndex="1000"
              @click="mostrarHorariosTramo(tramoRuta, $event)"
            ></gmap-marker>

            <!-- Marcadores pequeños visibles en el punto medio de cada tramo añadido -->
            <gmap-marker
              v-for="(tramoAñadido, index) in tramosAñadidosConPathEdit"
              :key="'marker-tramo-' + tramoAñadido.id + '-' + index"
              :position="obtenerPuntoMedioTramo(tramoAñadido)"
              :icon="
                googleSymbolPath
                  ? {
                      path: googleSymbolPath.CIRCLE,
                      scale: 6,
                      fillColor: '#00529c',
                      fillOpacity: 0.6,
                      strokeColor: '#FFFFFF',
                      strokeWeight: 2,
                    }
                  : null
              "
              :zIndex="1000"
              @click="mostrarHorariosTramo(tramoAñadido, $event)"
            ></gmap-marker>

            <!-- Líneas de conexión entre tramos -->
            <gmap-polyline
              v-for="(conexion, index) in conexionesEntreTramos"
              :key="'conexion-' + index"
              :options="{
                strokeColor: '#FF9800',
                strokeOpacity: '0.8',
                strokeWeight: 3,
                icons: [
                  {
                    icon: {
                      path: googleSymbolPath
                        ? googleSymbolPath.FORWARD_CLOSED_ARROW
                        : null,
                      scale: 4,
                      strokeColor: '#FF9800',
                    },
                    offset: '50%',
                    repeat: '100px',
                  },
                ],
              }"
              :path="conexion.path"
            ></gmap-polyline>

            <!-- Marcadores de conexión entre tramos -->
            <gmap-marker
              v-for="(conexion, index) in conexionesEntreTramos"
              :key="'marker-conexion-' + index"
              :position="conexion.position"
              :icon="{
                path: googleSymbolPath ? googleSymbolPath.CIRCLE : null,
                scale: 8,
                fillColor: '#FF9800',
                fillOpacity: 1,
                strokeColor: '#FFFFFF',
                strokeWeight: 2,
              }"
            ></gmap-marker>

            <!-- Info Window para mostrar información de los tramos -->
            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </div>
      </div>
    </div>
    <!-- Paneles Visualización -->
    <div class="col-lg-5">
      <div class="card shadow-sm border border-gray rounded">
        <div class="card-header bg-white border-0 border-bottom py-3">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0 font-weight-bold text-dark">Detalle de Ruta</h5>
            <!-- v-if="ruta && ruta.ruta_polilineas.length > 0" -->
            <button
              type="button"
              class="btn btn-outline-primary btn-sm float-right"
              data-toggle="modal"
              data-target="#modal_indicaciones_ruta"
            >
              <i class="fas fa-map-marked-alt mr-1"></i> Indicaciones
            </button>
          </div>
        </div>
        <!-- Tabla Puntos Mapa - Solo se muestra cuando el check de editar está activo -->
        <div class="card-body p-0" v-if="accion_ruta">
          <TifRutaTramo
            ref="tifRutaTramo"
            :accionRuta="accion_ruta"
          ></TifRutaTramo>
        </div>
        <!-- Tabla de tramos cuando no está en modo edición y hay tramos -->
        <div v-else-if="listaTramosRuta.length > 0">
          <div class="card-header bg-primary text-white py-3">
            <h5 class="mb-0 d-flex align-items-center">
              <i class="fas fa-route mr-2"></i>
              Tramos de la Ruta
              <span class="badge badge-light badge-pill ml-2">{{
                listaTramosRuta.length
              }}</span>
            </h5>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">#</th>
                    <th>Nombre del Tramo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ruta, index) in listaTramosRuta" :key="ruta.id || index">
                    <td class="text-center align-middle">
                      <span class="badge badge-primary badge-pill">{{
                        index + 1
                      }}</span>
                    </td>
                    <td class="align-middle">
                      <i class="fas fa-map-marker-alt text-primary mr-2"></i>
                      {{
                        (ruta.tramo_ruta && ruta.tramo_ruta.nombre) || ruta.nombre || "Sin nombre"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Mensaje cuando no está en modo edición y no hay tramos -->
        <div class="card-body p-4" v-else>
          <div class="alert alert-light border text-center mb-0">
            <i class="fas fa-info-circle text-info fa-lg mb-2"></i>
            <p class="mb-0 font-weight-medium">
              Activa el modo <strong>Editar Ruta</strong> para gestionar los
              tramos.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Indicaciones Ruta -->
    <div class="modal fade" id="modal_indicaciones_ruta">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo pt-2 pb-2">
            <h4 class="modal-title text-white">Indicaciones de Ruta</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <PanelIndicacionesRuta
              ref="PanelIndicacionesRuta"
            ></PanelIndicacionesRuta>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
const google = window.google;
import PanelIndicacionesRuta from "../../../../components/PanelIndicacionesRuta";
import TifRutaTramo from "./TifRutaTramo";
export default {
  name: "TifRutaDetalle",

  components: {
    PanelIndicacionesRuta,
    TifRutaTramo,
  },

  data() {
    return {
      ruta: null,
      tipo_sitio_img: "image/iconos/default.png",
      inicio_ruta: "image/iconos/inicio_ruta.png",
      fin_ruta: "image/iconos/fin_ruta.png",
      inicio_vel_max: "image/iconos/tacom-green.png",
      fin_vel_max: "image/iconos/tacom-red.png",
      latitud_ini: 4.651371,
      longitud_ini: -74.071509,
      form: {},
      coords: {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      },
      viewMap: {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        nodos: false,
      },
      markers: {
        inicio_ruta: null,
        fin_ruta: null,
        ruta: {
          path: [],
          options: {
            strokeColor: "#00529c",
            strokeOpacity: "0.9",
            strokeWeight: 5,
          },
        },
        waypoints: [],
      },
      accion_ruta: false,
      accion_coordenadas: false,
      // Datos para el cuadro de información del mapa
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      addressInput: "",
      ListasForm: {
        codigosDane: [],
      },
      url_docs: process.env.VUE_APP_API_URL,
      mvcPath: null,
      tramosAñadidos: [], // Tramos añadidos desde TifRutaTramo
      tramosRuta: [], // Tramos de la ruta obtenidos del backend
      tramoHoverActual: null, // Para el tooltip de velocidad máxima
      tooltipTimeout: null, // Para controlar el timeout del tooltip
    };
  },

  validations: {},

  watch: {
    polylinePath: function (path) {
      if (path) {
        this.markers.ruta.path = path;
      }
    },

    accion_ruta: function (nuevoValor) {
      // Si se desactiva el modo de edición, limpiar los tramos añadidos
      if (!nuevoValor) {
        this.tramosAñadidos = [];
        // También limpiar en el componente hijo si existe
        if (this.$refs.tifRutaTramo) {
          this.$refs.tifRutaTramo.tramosAñadidos = [];
        }
      } else {
        // Si se activa el modo de edición y hay tramos existentes, cargarlos
        const listaTramos = this.listaTramosRuta;
        if (listaTramos.length > 0 && this.tramosAñadidos.length === 0) {
          // Copiar los tramos con una copia profunda para mantener el path
          this.tramosAñadidos = listaTramos.map((t) => {
            const tramoCopia = JSON.parse(JSON.stringify(t));
            return tramoCopia;
          });
          // Cargar también en el componente hijo
          this.$nextTick(() => {
            if (this.$refs.tifRutaTramo) {
              this.$refs.tifRutaTramo.tramosAñadidos = listaTramos.map(
                (t) => {
                  const tramoCopia = JSON.parse(JSON.stringify(t));
                  return tramoCopia;
                }
              );
              this.$refs.tifRutaTramo.obtenerPuntoReferencia();
              this.$refs.tifRutaTramo.filtrarTramosCercanos();
            }
          });
        }
      }
    },
  },

  computed: {
    polylinePath: function () {
      if (!this.mvcPath) return null;

      let path = [];
      for (let j = 0; j < this.mvcPath.getLength(); j++) {
        let point = this.mvcPath.getAt(j);
        path.push({ lat: point.lat(), lng: point.lng() });
      }
      return path;
    },

    tramosAñadidosConPath: function () {
      return this.tramosAñadidos.filter(
        (tramo) => tramo.path && tramo.path.length > 0
      );
    },

    listaTramosRuta: function () {
      const t = this.tramosRuta;
      if (!t) return [];
      return Array.isArray(t.ruta) ? t.ruta : Array.isArray(t) ? t : [];
    },

    tramosRutaConPath: function () {
      if (this.accion_ruta) {
        return [];
      }
      const tramos = this.tramosRuta;
      if (!tramos) return [];

      // Caso 1: API devuelve { detTramosRutasOrdenados: [...] }
      const detOrdenados =
        tramos.detTramosRutasOrdenados && Array.isArray(tramos.detTramosRutasOrdenados)
          ? tramos.detTramosRutasOrdenados
          : null;
      if (detOrdenados && detOrdenados.length > 0) {
        return detOrdenados
          .map((tramo, idx) => {
            const path = [];
            const puntos = Array.isArray(tramo) ? tramo : tramo.detTramosRutasOrdenados || tramo.path || [];
            if (puntos.length > 0) {
              puntos.forEach((det, i) => {
                if (det.lat_ini != null && det.lon_ini != null) {
                  if (i === 0) path.push({ lat: parseFloat(det.lat_ini), lng: parseFloat(det.lon_ini) });
                  if (det.lat_fin != null && det.lon_fin != null) {
                    path.push({ lat: parseFloat(det.lat_fin), lng: parseFloat(det.lon_fin) });
                  }
                } else if (det.lat != null && det.lng != null) {
                  path.push({ lat: parseFloat(det.lat), lng: parseFloat(det.lng) });
                }
              });
            }
            return {
              id: tramo.id || (tramo[0] && tramo[0].id) || idx,
              path: path.length >= 2 ? path : [],
              color: tramo.color,
            };
          })
          .filter((t) => t.path.length >= 2);
      }

      // Caso 2: API devuelve { ruta: [...] } o array de tramos
      const listaTramos = Array.isArray(tramos.ruta) ? tramos.ruta : Array.isArray(tramos) ? tramos : [];
      if (listaTramos.length === 0) return [];

      return listaTramos
        .map((tramo, idx) => {
          const t = tramo.tramo_ruta || tramo;
          let path = [];
          if (tramo.path && Array.isArray(tramo.path) && tramo.path.length > 0) {
            path = tramo.path.map((p) => ({
              lat: parseFloat(p.lat),
              lng: parseFloat(p.lng),
            }));
          } else if (t.path && Array.isArray(t.path) && t.path.length > 0) {
            path = t.path.map((p) => ({
              lat: parseFloat(p.lat),
              lng: parseFloat(p.lng),
            }));
          } else if ((tramo.det_tramos_rutas || t.det_tramos_rutas) && (tramo.det_tramos_rutas || t.det_tramos_rutas).length > 0) {
            const dets = tramo.det_tramos_rutas || t.det_tramos_rutas;
            dets.forEach((det, i) => {
              if (i === 0) path.push({ lat: parseFloat(det.lat_ini), lng: parseFloat(det.lon_ini) });
              path.push({ lat: parseFloat(det.lat_fin), lng: parseFloat(det.lon_fin) });
            });
          } else if (
            (tramo.lat_origen != null || t.lat_origen != null) &&
            (tramo.lng_origen != null || t.lng_origen != null) &&
            (tramo.lat_destino != null || t.lat_destino != null) &&
            (tramo.lng_destino != null || t.lng_destino != null)
          ) {
            const latOr = tramo.lat_origen ?? t.lat_origen;
            const lngOr = tramo.lng_origen ?? t.lng_origen;
            const latDe = tramo.lat_destino ?? t.lat_destino;
            const lngDe = tramo.lng_destino ?? t.lng_destino;
            path = [
              { lat: parseFloat(latOr), lng: parseFloat(lngOr) },
              { lat: parseFloat(latDe), lng: parseFloat(lngDe) },
            ];
          }
          return {
            id: tramo.id || t.id || idx,
            path,
            color: tramo.color || t.color,
          };
        })
        .filter((t) => t.path.length >= 2);
    },

    tramosAñadidosConPathEdit: function () {
      if (!this.accion_ruta) {
        return []; // No mostrar tramos añadidos cuando no está en modo edición
      }
      return this.tramosAñadidos.filter(
        (tramo) => tramo.path && tramo.path.length > 0
      );
    },

    conexionesEntreTramos: function () {
      const conexiones = [];

      // Si hay más de un tramo, crear conexiones entre ellos
      for (let i = 0; i < this.tramosAñadidos.length - 1; i++) {
        const tramoActual = this.tramosAñadidos[i];
        const tramoSiguiente = this.tramosAñadidos[i + 1];

        if (
          tramoActual.lat_destino &&
          tramoActual.lng_destino &&
          tramoSiguiente.lat_origen &&
          tramoSiguiente.lng_origen
        ) {
          const destinoActual = {
            lat: parseFloat(tramoActual.lat_destino),
            lng: parseFloat(tramoActual.lng_destino),
          };
          const origenSiguiente = {
            lat: parseFloat(tramoSiguiente.lat_origen),
            lng: parseFloat(tramoSiguiente.lng_origen),
          };

          conexiones.push({
            path: [destinoActual, origenSiguiente],
            position: destinoActual, // Marcador en el punto de conexión
          });
        }
      }

      return conexiones;
    },

    googleSymbolPath() {
      if (google && google.maps && google.maps.SymbolPath) {
        return google.maps.SymbolPath;
      }
      return null;
    },
  },

  methods: {
    async getIndex() {
      this.resetDatos();
      this.ruta = this.$parent.form ? this.$parent.form : null;

      if (this.ruta.waypoints) {
        this.markers.waypoints = JSON.parse(this.ruta.waypoints).map(function (
          waypoint
        ) {
          return {
            location: {
              lat: parseFloat(waypoint.location.lat),
              lng: parseFloat(waypoint.location.lng),
            },
            stopover: true,
          };
        });
      } else {
        this.markers.waypoints = [];
      }

      this.tipo_sitio_img = "image/iconos/default.png";
      //this.getMarkersRuta();
      await this.obtenerRutasTramos();
      await this.getPanelRuta();
    },

    resetDatos() {
      this.ruta = null;
      this.form = {};
      this.viewMap = {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        nodos: false,
      };

      this.markers = {
        inicio_ruta: null,
        fin_ruta: null,
        ruta: {
          path: [],
          options: {
            strokeColor: "#00529c",
            strokeOpacity: "0.9",
            strokeWeight: 5,
          },
        },
        waypoints: [],
      };
    },

    toggleInfoWindow: function (data) {
      this.infoWindowPos = data.position;
      this.infoContent = data.html;

      //compruebe si es el mismo marcador que se seleccionó en caso afirmativo alternar
      if (this.currentMidx == data.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si es un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = data.id;
      }
    },

    getMarkersRuta() {
      this.markers.inicio_ruta = null;
      this.markers.fin_ruta = null;

      if (this.ruta) {
        let latOrigen = null;
        let lngOrigen = null;
        let latDestino = null;
        let lngDestino = null;

        // Prioridad 1: Buscar en lat_origen/lng_origen directos
        if (this.ruta.lat_origen && this.ruta.lng_origen) {
          latOrigen = parseFloat(this.ruta.lat_origen);
          lngOrigen = parseFloat(this.ruta.lng_origen);
        }
        // Prioridad 2: Buscar en la relación origen
        else if (this.ruta.origen) {
          const origen = this.ruta.origen;
          // Intentar diferentes nombres de campos comunes
          latOrigen = origen.latitud || origen.lat || origen.lat_origen;
          lngOrigen =
            origen.longitud || origen.lng || origen.lng_origen || origen.lon;
          if (latOrigen && lngOrigen) {
            latOrigen = parseFloat(latOrigen);
            lngOrigen = parseFloat(lngOrigen);
          } else {
            latOrigen = null;
            lngOrigen = null;
          }
        }

        // Prioridad 1: Buscar en lat_destino/lng_destino directos
        if (this.ruta.lat_destino && this.ruta.lng_destino) {
          latDestino = parseFloat(this.ruta.lat_destino);
          lngDestino = parseFloat(this.ruta.lng_destino);
        }
        // Prioridad 2: Buscar en la relación destino
        else if (this.ruta.destino) {
          const destino = this.ruta.destino;
          // Intentar diferentes nombres de campos comunes
          latDestino = destino.latitud || destino.lat || destino.lat_destino;
          lngDestino =
            destino.longitud ||
            destino.lng ||
            destino.lng_destino ||
            destino.lon;
          if (latDestino && lngDestino) {
            latDestino = parseFloat(latDestino);
            lngDestino = parseFloat(lngDestino);
          } else {
            latDestino = null;
            lngDestino = null;
          }
        }

        // Establecer marcador de inicio
        if (latOrigen && lngOrigen) {
          this.markers.inicio_ruta = {
            icon: this.inicio_ruta,
            position: {
              lat: latOrigen,
              lng: lngOrigen,
            },
          };
        } else if (
          this.ruta.ruta_polilineas &&
          this.ruta.ruta_polilineas.length > 0
        ) {
          // Usar el primer punto de las polilíneas como origen
          this.markers.inicio_ruta = {
            icon: this.inicio_ruta,
            position: {
              lat: parseFloat(this.ruta.ruta_polilineas[0].lat_ini),
              lng: parseFloat(this.ruta.ruta_polilineas[0].lon_ini),
            },
          };
        }

        // Establecer marcador de fin
        if (latDestino && lngDestino) {
          this.markers.fin_ruta = {
            icon: this.fin_ruta,
            position: {
              lat: latDestino,
              lng: lngDestino,
            },
          };
        } else if (
          this.ruta.ruta_polilineas &&
          this.ruta.ruta_polilineas.length > 0
        ) {
          // Usar el último punto de las polilíneas como destino
          const ultimoPunto =
            this.ruta.ruta_polilineas[this.ruta.ruta_polilineas.length - 1];
          this.markers.fin_ruta = {
            icon: this.fin_ruta,
            position: {
              lat: parseFloat(ultimoPunto.lat_fin),
              lng: parseFloat(ultimoPunto.lon_fin),
            },
          };
        }

        // Se genera los puntos de la ruta a mostrar (solo si hay polilíneas)
        this.markers.ruta.path = [];
        if (this.ruta.ruta_polilineas && this.ruta.ruta_polilineas.length > 0) {
          this.ruta.ruta_polilineas.forEach((det) => {
            if (det.orden == 1) {
              this.markers.ruta.path.push({
                lat: parseFloat(det.lat_ini),
                lng: parseFloat(det.lon_ini),
              });
            }
            this.markers.ruta.path.push({
              lat: parseFloat(det.lat_fin),
              lng: parseFloat(det.lon_fin),
            });
          });
        }
      }

      // Usar $nextTick para asegurar que los marcadores estén actualizados antes de centrar
      this.$nextTick(() => {
        this.centrarMapa();
      });
    },

    async getPanelRuta() {
      if (this.tramosRuta.ruta && this.tramosRuta.detTramosRutasOrdenados) {
        this.$refs.PanelIndicacionesRuta.getIndex(
          this.tramosRuta.ruta,
          JSON.stringify(this.tramosRuta.detTramosRutasOrdenados)
        );
      }
    },

    // Funciones para el manejo general del mapa
    centrarMapa() {
      // Verificar que los marcadores existan y tengan posición
      if (
        this.markers.inicio_ruta &&
        this.markers.inicio_ruta.position &&
        this.markers.fin_ruta &&
        this.markers.fin_ruta.position
      ) {
        const inicio = this.markers.inicio_ruta.position;
        const fin = this.markers.fin_ruta.position;
        this.viewMap.center = {
          lat: (inicio.lat + fin.lat) / 2,
          lng: (inicio.lng + fin.lng) / 2,
        };
        const distancia = this.calcularDistancia(inicio, fin);
        this.viewMap.zoom = this.calcularZoomMapa(distancia);
      } else if (
        this.markers.inicio_ruta &&
        this.markers.inicio_ruta.position
      ) {
        const inicio = this.markers.inicio_ruta.position;
        this.viewMap.center = {
          lat: inicio.lat,
          lng: inicio.lng,
        };
        this.viewMap.zoom = 12; // Zoom por defecto si solo hay origen
      } else if (this.markers.fin_ruta && this.markers.fin_ruta.position) {
        const fin = this.markers.fin_ruta.position;
        this.viewMap.center = {
          lat: fin.lat,
          lng: fin.lng,
        };
        this.viewMap.zoom = 12; // Zoom por defecto si solo hay destino
      } else {
        // Si no hay marcadores, usar coordenadas por defecto
        this.viewMap.center = {
          lat: this.latitud_ini,
          lng: this.longitud_ini,
        };
        this.viewMap.zoom = 12;
      }
    },

    calcularDistancia(origin, destination) {
      return google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(origin.lat, origin.lng),
        new google.maps.LatLng(destination.lat, destination.lng)
      );
    },

    calcularZoomMapa(distancia) {
      return Math.max(
        1,
        Math.min(Math.round(16 - Math.log2(distancia / 1000)), 18)
      );
    },

    async calcularRuta() {
      this.$parent.cargando = true;
      // Se calcula la ruta entre los dos puntos
      const directionsService = new google.maps.DirectionsService();
      const request = {
        origin: this.markers.inicio_ruta.position,
        destination: this.markers.fin_ruta.position,
        waypoints: this.markers.waypoints,
        travelMode: "DRIVING",
      };
      let allCoordinates = [];
      await directionsService.route(request, (result, status) => {
        if (status === "OK") {
          this.markers.ruta.path = [];
          // Usando los path de los pasos que indica google routes

          result.routes.forEach((route) => {
            route.legs.forEach((leg) => {
              leg.steps.forEach((stp) => {
                // Usar map() para extraer todas las latitudes y longitudes sin usar un bucle explícito
                const stepCoordinates = stp.path.map((element) => ({
                  lat: element.lat(),
                  lng: element.lng(),
                }));

                // Combinar los puntos obtenidos en el arreglo final
                allCoordinates = allCoordinates.concat(stepCoordinates);
              });
            });
          });

          //this.markers.ruta.path = allCoordinates;

          // Se ajusta la posicion de los markers de inicio y fin de la ruta
          /* this.markers.inicio_ruta = {
            icon: this.inicio_ruta,
            position: {
              lat: parseFloat(allCoordinates[0].lat),
              lng: parseFloat(allCoordinates[0].lng),
            },
          }; */

          /* this.markers.fin_ruta = {
            icon: this.fin_ruta,
            position: {
              lat: parseFloat(allCoordinates[allCoordinates.length - 1].lat),
              lng: parseFloat(allCoordinates[allCoordinates.length - 1].lng),
            },
          }; */

          this.$parent.cargando = false;
        } else {
          this.$parent.cargando = false;
          this.getMarkersRuta();
          this.$swal({
            icon: "error",
            title: "No se pudo cargar la ruta: " + status,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      });

      // Ejemplo de uso:
      let polylinePoints = allCoordinates;

      let tolerance = 0.00025; // Tolerancia para simplificar la polilínea (ajústala según necesites)
      let ressimplifiedPolyline = await this.simplifyPolyline(
        polylinePoints,
        tolerance
      );
      this.markers.ruta.path = ressimplifiedPolyline;
    },
    // Fin - Funciones para el manejo general del mapa

    // Funciones que vienen del autocomplete de google
    setPlaceOrigen(place) {
      this.markers.inicio_ruta = {
        icon: this.inicio_ruta,
        position: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        },
      };

      this.markers.ruta.path[0] = {
        lat: parseFloat(place.geometry.location.lat()),
        lng: parseFloat(place.geometry.location.lng()),
      };

      if (this.markers.fin_ruta) {
        this.calcularRuta();
      }
      this.centrarMapa();
    },

    setPlaceDestino(place) {
      this.markers.fin_ruta = {
        icon: this.fin_ruta,
        position: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        },
      };

      if (this.markers.ruta.path.length > 1) {
        this.markers.ruta.path[this.markers.ruta.path.length - 1] = {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        };
      } else {
        this.markers.ruta.path.push({
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        });
      }
      this.calcularRuta();
      this.centrarMapa();
    },

    setPlaceWaypoint(place) {
      this.markers.waypoints.push({
        location: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng()),
        },
        stopover: true,
      });
      this.calcularRuta();
      this.centrarMapa();
    },

    actDatos() {
      this.calcularRuta();
      this.centrarMapa();
    },
    // Fin - Funciones que vienen del autocomplete de google

    handleClickForDelete($event) {
      if ($event.vertex !== undefined) {
        this.markers.ruta.path.splice($event.vertex, 1);
      }
    },

    updateEdited: function (mvcPath) {
      this.mvcPath = mvcPath;
    },

    // Funciones que vienen de los campos de coordenadas
    resetCoors() {
      this.coords = {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      };
    },

    setCoordOrigen() {
      if (this.coords.lat_origen && this.coords.lng_origen) {
        this.markers.inicio_ruta = {
          icon: this.inicio_ruta,
          position: {
            lat: parseFloat(this.coords.lat_origen),
            lng: parseFloat(this.coords.lng_origen),
          },
        };

        this.markers.ruta.path[0] = {
          lat: parseFloat(this.coords.lat_origen),
          lng: parseFloat(this.coords.lng_origen),
        };

        if (this.markers.fin_ruta) {
          this.calcularRuta();
        }
        this.centrarMapa();
      }
    },

    setCoordDestino() {
      if (this.coords.lat_destino && this.coords.lng_destino) {
        this.markers.fin_ruta = {
          icon: this.fin_ruta,
          position: {
            lat: parseFloat(this.coords.lat_destino),
            lng: parseFloat(this.coords.lng_destino),
          },
        };

        if (this.markers.ruta.path.length > 1) {
          this.markers.ruta.path[this.markers.ruta.path.length - 1] = {
            lat: parseFloat(this.coords.lat_destino),
            lng: parseFloat(this.coords.lng_destino),
          };
        } else {
          this.markers.ruta.path.push({
            lat: parseFloat(this.coords.lat_destino),
            lng: parseFloat(this.coords.lng_destino),
          });
        }
        this.calcularRuta();
        this.centrarMapa();
      }
    },
    // Fin - Funciones que vienen de los campos de coordenadas

    // Funciones para los waypoints
    editWaypoint(event, index) {
      this.markers.waypoints[index] = {
        location: {
          lat: parseFloat(event.latLng.lat()),
          lng: parseFloat(event.latLng.lng()),
        },
        stopover: true,
      };
      this.calcularRuta();
    },

    removeWaypoint(index) {
      this.markers.waypoints.splice(index, 1);
      this.calcularRuta();
    },

    save() {
      this.$swal({
        title: "Está seguro de editar esta ruta?",
        text: "Se ha modificado el origen o el destino de esta ruta!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Modificar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          this.form = {
            id: this.ruta.id,
            path: this.markers.ruta.path,
            waypoints: JSON.stringify(this.markers.waypoints),
            lng_origen: this.markers.inicio_ruta.position.lng,
            lat_origen: this.markers.inicio_ruta.position.lat,
            lng_destino: this.markers.fin_ruta.position.lng,
            lat_destino: this.markers.fin_ruta.position.lat,
          };

          axios
            .post("/api/tif/rutas/saveDetalle", this.form)
            .then((response) => {
              this.$parent.cargando = false;
              this.accion_ruta = false;
              this.$parent.getIndex();

              this.$swal({
                icon: "success",
                title: "Se guardó exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            })
            .catch((error) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "error",
                title: "Ocurrió un error: " + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    // Función para calcular la distancia perpendicular entre un punto y una línea definida por dos puntos
    perpendicularDistance(point, lineStart, lineEnd) {
      let x = point.lat;
      let y = point.lng;
      let x1 = lineStart.lat;
      let y1 = lineStart.lng;
      let x2 = lineEnd.lat;
      let y2 = lineEnd.lng;

      let numerator = Math.abs(
        (y2 - y1) * x - (x2 - x1) * y + x2 * y1 - y2 * x1
      );
      let denominator = Math.sqrt(Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2));

      return denominator === 0 ? 0 : numerator / denominator;
    },

    // Algoritmo Douglas-Peucker
    douglasPeucker(points, tolerance) {
      if (points.length < 3) {
        return points;
      }

      let maxDistance = 0;
      let index = 0;
      let startPoint = points[0];
      let endPoint = points[points.length - 1];

      // Encontrar el punto con la mayor distancia perpendicular al segmento
      for (let i = 1; i < points.length - 1; i++) {
        let distance = this.perpendicularDistance(
          points[i],
          startPoint,
          endPoint
        );
        if (distance > maxDistance) {
          index = i;
          maxDistance = distance;
        }
      }

      // Si la distancia máxima es mayor que el umbral de tolerancia, dividir la polilínea
      if (maxDistance > tolerance) {
        let left = this.douglasPeucker(points.slice(0, index + 1), tolerance);
        let right = this.douglasPeucker(points.slice(index), tolerance);

        return left.slice(0, left.length - 1).concat(right);
      } else {
        // Si no hay puntos significativos, devolver los extremos
        return [startPoint, endPoint];
      }
    },

    // Función para simplificar la polilínea
    simplifyPolyline(points, tolerance) {
      if (!points || points.length === 0) return [];
      return this.douglasPeucker(points, tolerance);
    },

    // Método para pintar un tramo en el mapa
    async pintarTramoEnMapa(tramo) {
      try {
        // El tramo ya viene completo desde tifRutaTramo.vue
        let path = [];

        // Si el tramo ya tiene path, usarlo
        if (tramo.path && Array.isArray(tramo.path) && tramo.path.length > 0) {
          path = tramo.path;
        } else if (
          tramo.det_tramos_rutas &&
          tramo.det_tramos_rutas.length > 0
        ) {
          // Construir el path del tramo desde det_tramos_rutas
          tramo.det_tramos_rutas.forEach((det) => {
            if (det.orden == 1) {
              path.push({
                lat: parseFloat(det.lat_ini),
                lng: parseFloat(det.lon_ini),
              });
            }
            path.push({
              lat: parseFloat(det.lat_fin),
              lng: parseFloat(det.lon_fin),
            });
          });
        } else if (
          tramo.lat_origen &&
          tramo.lng_origen &&
          tramo.lat_destino &&
          tramo.lng_destino
        ) {
          // Si no hay det_tramos_rutas, crear un path simple desde origen a destino
          path = [
            {
              lat: parseFloat(tramo.lat_origen),
              lng: parseFloat(tramo.lng_origen),
            },
            {
              lat: parseFloat(tramo.lat_destino),
              lng: parseFloat(tramo.lng_destino),
            },
          ];
        }

        // Añadir el tramo con su path al array de tramos añadidos
        // Verificar si el tramo ya existe para evitar duplicados
        const tramoExistente = this.tramosAñadidos.find(
          (t) => t.id === tramo.id
        );
        if (!tramoExistente) {
          this.tramosAñadidos.push({
            ...tramo,
            path: path,
          });
        } else {
          // Si ya existe, actualizar su path
          const index = this.tramosAñadidos.findIndex((t) => t.id === tramo.id);
          this.tramosAñadidos[index] = {
            ...this.tramosAñadidos[index],
            ...tramo,
            path: path,
          };
        }
        // Centrar el mapa en el tramo añadido
        this.centrarMapaEnTramo({ ...tramo, path });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error al cargar el tramo: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    centrarMapaEnTramo(tramo) {
      const centro = this.obtenerPuntoMedioTramo(tramo);
      if (centro && centro.lat && centro.lng) {
        this.viewMap.center = { ...centro };
        this.viewMap.zoom = 14;
      }
    },

    centrarMapaEnTramos() {
      const tramos = this.tramosRutaConPath;
      if (!tramos || tramos.length === 0) return;
      const todosLosPuntos = [];
      tramos.forEach((t) => {
        if (t.path && t.path.length > 0) {
          t.path.forEach((p) => {
            const lat = typeof p.lat === "function" ? p.lat() : parseFloat(p.lat);
            const lng = typeof p.lng === "function" ? p.lng() : parseFloat(p.lng);
            if (lat != null && lng != null && !isNaN(lat) && !isNaN(lng)) {
              todosLosPuntos.push({ lat, lng });
            }
          });
        }
      });
      if (todosLosPuntos.length === 0) return;
      let minLat = todosLosPuntos[0].lat;
      let maxLat = todosLosPuntos[0].lat;
      let minLng = todosLosPuntos[0].lng;
      let maxLng = todosLosPuntos[0].lng;
      todosLosPuntos.forEach((p) => {
        if (p.lat < minLat) minLat = p.lat;
        if (p.lat > maxLat) maxLat = p.lat;
        if (p.lng < minLng) minLng = p.lng;
        if (p.lng > maxLng) maxLng = p.lng;
      });
      this.viewMap.center = {
        lat: (minLat + maxLat) / 2,
        lng: (minLng + maxLng) / 2,
      };
      const spanLat = maxLat - minLat;
      const spanLng = maxLng - minLng;
      const distanciaAprox = this.calcularDistancia(
        { lat: minLat, lng: minLng },
        { lat: maxLat, lng: maxLng }
      );
      this.viewMap.zoom = this.calcularZoomMapa(Math.max(distanciaAprox, 500));
    },
    obtenerPuntoMedioTramo(tramo) {
      if (!tramo.path || tramo.path.length === 0) {
        // Si no hay path, usar el punto medio entre origen y destino
        if (
          tramo.lat_origen &&
          tramo.lng_origen &&
          tramo.lat_destino &&
          tramo.lng_destino
        ) {
          return {
            lat:
              (parseFloat(tramo.lat_origen) + parseFloat(tramo.lat_destino)) /
              2,
            lng:
              (parseFloat(tramo.lng_origen) + parseFloat(tramo.lng_destino)) /
              2,
          };
        }
        return { lat: 0, lng: 0 };
      }

      // Obtener el punto medio del path
      const puntoMedio = Math.floor(tramo.path.length / 2);
      return tramo.path[puntoMedio];
    },

    manejarClickTramo(tramo, event) {
      // Si el click viene del polyline, mostrar velocidad máxima
      // El click en el marcador mostrará los horarios
      let position = null;

      if (event && event.latLng) {
        position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
      } else {
        // Si no hay latLng en el evento, usar el punto medio del tramo
        position = this.obtenerPuntoMedioTramo(tramo);
      }

      const velocidadMaxima = tramo.vel_max || tramo.km_max || "No definida";
      const contenido = `
        <div class="p-2">
          <strong>${tramo.nombre || "Tramo"}</strong><br/>
          <small>Velocidad Máxima: <strong>${velocidadMaxima} km/h</strong></small><br/>
          <small class="text-muted small">Haz click en el marcador para ver horarios</small>
        </div>
      `;

      this.infoWindowPos = position;
      this.infoContent = contenido;
      this.infoWinOpen = true;
      this.currentMidx = `velocidad-${tramo.id}`;

      // Cerrar el tooltip después de 4 segundos
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      this.tooltipTimeout = setTimeout(() => {
        if (this.currentMidx === `velocidad-${tramo.id}`) {
          this.infoWinOpen = false;
        }
      }, 4000);
    },

    mostrarHorariosTramo(tramo, event) {
      // Limpiar timeout del tooltip si existe
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }

      // Verificar si el tramo tiene horarios
      if (!tramo.horarios || tramo.horarios.length === 0) {
        this.$swal({
          icon: "info",
          title: "Sin horarios",
          text: "Este tramo no tiene horarios configurados.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      // Construir el contenido HTML con los horarios
      let contenido = `
        <div class="p-2">
          <h6 class="mb-2 font-weight-bold">${tramo.nombre || "Tramo"}</h6>
          <h6 class="mb-2 text-primary small">Horarios Permitidos de Tránsito</h6>
          <table class="table table-sm table-bordered small">
            <thead class="thead-light">
              <tr>
                <th class="text-left p-1">Día</th>
                <th class="text-left p-1">Inicio</th>
                <th class="text-left p-1">Fin</th>
              </tr>
            </thead>
            <tbody>
      `;

      const diasSemana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];

      // Función para obtener el nombre del día
      // El backend puede usar 1-7 (1=Lunes, 7=Domingo) o 0-6 (0=Lunes, 6=Sábado, 7=Domingo)
      const obtenerNombreDia = (diaSemana) => {
        // Si es 7, es Domingo (índice 0)
        if (diaSemana === 7) {
          return "Domingo";
        }
        // Si es 1-6, mapear a índice 1-6 (Lunes-Sábado)
        if (diaSemana >= 1 && diaSemana <= 6) {
          return diasSemana[diaSemana] || `Día ${diaSemana}`;
        }
        // Si es 0, es Lunes (índice 1)
        if (diaSemana === 0) {
          return "Lunes";
        }
        // Fallback
        return diasSemana[diaSemana] || `Día ${diaSemana}`;
      };

      tramo.horarios.forEach((horario) => {
        const diaNombre = obtenerNombreDia(horario.dia_semana);
        const horarioIni = horario.horario_ini || "N/A";
        const horarioFin = horario.horario_fin || "N/A";

        contenido += `
          <tr>
            <td class="p-1">${diaNombre}</td>
            <td class="p-1">${horarioIni}</td>
            <td class="p-1">${horarioFin}</td>
          </tr>
        `;
      });

      contenido += `
            </tbody>
          </table>
      `;

      if (tramo.horarios.some((h) => h.observacion)) {
        contenido += `<div class="mt-2 text-muted small">`;
        tramo.horarios.forEach((horario) => {
          if (horario.observacion) {
            const diaNombre = obtenerNombreDia(horario.dia_semana);
            contenido += `<p class="my-1"><strong>${diaNombre}:</strong> ${horario.observacion}</p>`;
          }
        });
        contenido += `</div>`;
      }

      contenido += `</div>`;

      this.infoWindowPos = this.obtenerPuntoMedioTramo(tramo);
      this.infoContent = contenido;
      this.infoWinOpen = true;
      this.currentMidx = `horarios-${tramo.id}`;
    },

    async obtenerRutasTramos() {
      if (!this.ruta || !this.ruta.id) return;
      try {
        const response = await axios.get(`/api/tif/rutas/tramos/${this.ruta.id}`);
        const data = response.data;
        const listaCruda = Array.isArray(data) ? data : (data.ruta || data.data || []);
        if (!listaCruda.length) {
          this.tramosRuta = { ruta: [] };
          return;
        }
        // Enriquecer cada tramo con path (detalle desde API si no viene)
        const promesas = listaCruda.map((tramo) => {
          const tramoId = tramo.tramo_ruta_id || tramo.id || tramo.tramo_ruta?.id;
          const yaTienePath = (tramo.path && tramo.path.length > 0) ||
            (tramo.det_tramos_rutas && tramo.det_tramos_rutas.length > 0);
          if (yaTienePath) {
            return Promise.resolve(tramo);
          }
          if (!tramoId) return Promise.resolve(tramo);
          return axios
            .get(`/api/tif/tramosRutas/${tramoId}`)
            .then((tramoResponse) => {
              const completo = tramoResponse.data.data || tramoResponse.data;
              let path = [];
              if (completo.det_tramos_rutas && completo.det_tramos_rutas.length > 0) {
                completo.det_tramos_rutas.forEach((det) => {
                  if (det.orden == 1) {
                    path.push({ lat: parseFloat(det.lat_ini), lng: parseFloat(det.lon_ini) });
                  }
                  path.push({ lat: parseFloat(det.lat_fin), lng: parseFloat(det.lon_fin) });
                });
              } else if (completo.lat_origen != null && completo.lng_origen != null && completo.lat_destino != null && completo.lng_destino != null) {
                path = [
                  { lat: parseFloat(completo.lat_origen), lng: parseFloat(completo.lng_origen) },
                  { lat: parseFloat(completo.lat_destino), lng: parseFloat(completo.lng_destino) },
                ];
              }
              return { ...tramo, ...completo, path };
            })
            .catch(() => tramo);
        });
        const tramosCompletos = await Promise.all(promesas);
        this.tramosRuta = { ruta: tramosCompletos };
        this.$nextTick(() => this.centrarMapaEnTramos());
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error al obtener los tramos de la ruta: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.tramosRuta = { ruta: [] };
      }
    },

    /* obtenerRutasTramos() {
      axios
        .get(`/api/tif/rutas/tramos/${this.ruta.id}`)
        .then((response) => {
          const tramos = response.data;
          ///console.log(response.data);
          this.tramosRuta = response.data;

          // Obtener los datos completos de cada tramo
          const promesas = tramos.map((tramo) => {
            const tramoId =
              tramo.tramo_ruta_id || tramo.id || tramo.tramo_ruta?.id;
            if (!tramoId) {
              console.warn("Tramo sin ID válido:", tramo);
              return Promise.resolve(null);
            }

            return axios
              .get(`/api/tif/tramosRutas/${tramoId}`)
              .then((tramoResponse) => {
                const tramoCompleto =
                  tramoResponse.data.data || tramoResponse.data;
                // Construir el path del tramo
                let path = [];
                if (
                  tramoCompleto.det_tramos_rutas &&
                  tramoCompleto.det_tramos_rutas.length > 0
                ) {
                  tramoCompleto.det_tramos_rutas.forEach((det) => {
                    if (det.orden == 1) {
                      path.push({
                        lat: parseFloat(det.lat_ini),
                        lng: parseFloat(det.lon_ini),
                      });
                    }
                    path.push({
                      lat: parseFloat(det.lat_fin),
                      lng: parseFloat(det.lon_fin),
                    });
                  });
                } else if (
                  tramoCompleto.lat_origen &&
                  tramoCompleto.lng_origen &&
                  tramoCompleto.lat_destino &&
                  tramoCompleto.lng_destino
                ) {
                  path = [
                    {
                      lat: parseFloat(tramoCompleto.lat_origen),
                      lng: parseFloat(tramoCompleto.lng_origen),
                    },
                    {
                      lat: parseFloat(tramoCompleto.lat_destino),
                      lng: parseFloat(tramoCompleto.lng_destino),
                    },
                  ];
                }
                return {
                  ...tramoCompleto,
                  path: path,
                };
              })
              .catch((error) => {
                console.error(`Error al obtener tramo ${tramoId}:`, error);
                return null;
              });
          });

          Promise.all(promesas).then((tramosCompletos) => {
            this.tramosRuta = tramosCompletos.filter((t) => t !== null);
          });
        })
        .catch((error) => {
          console.error("Error al obtener tramos de la ruta:", error);
          this.tramosRuta = [];
        });
    }, */

    editarTramoRuta(tramo, index) {
      // Activar modo edición y cargar los tramos para poder cambiarlos
      this.accion_ruta = true;

      // Cargar los tramos existentes en tramosAñadidos del componente padre
      // para que se muestren en el mapa (copia profunda para mantener el path)
      this.tramosAñadidos = this.tramosRuta.map((t) => {
        const tramoCopia = JSON.parse(JSON.stringify(t));
        return tramoCopia;
      });

      // Cargar los tramos existentes en el componente TramosRutas
      this.$nextTick(() => {
        if (this.$refs.tifRutaTramo) {
          // Cargar los tramos de la ruta en el componente de edición
          this.$refs.tifRutaTramo.tramosAñadidos = this.tramosRuta.map((t) => {
            const tramoCopia = JSON.parse(JSON.stringify(t));
            return tramoCopia;
          });
          // Actualizar el punto de referencia para que muestre los tramos cercanos al destino del último tramo
          this.$refs.tifRutaTramo.obtenerPuntoReferencia();
          this.$refs.tifRutaTramo.filtrarTramosCercanos();
        }
      });
    },

    eliminarTramosDesde(index) {
      this.tramosAñadidos.splice(index);
    },

    guardarCadenaTramos(tramos) {
      this.$parent.cargando = true;

      // Construir el path completo de la ruta
      let fullPath = [];
      tramos.forEach((tramo, index) => {
        if (tramo.path && tramo.path.length > 0) {
          // Si es el primer tramo, añadir todo el path
          if (index === 0) {
            fullPath = fullPath.concat(tramo.path);
          } else {
            // Para tramos subsiguientes, añadir desde el segundo punto para evitar duplicados
            // asumiendo que el primer punto del tramo actual es el mismo que el último del anterior
            fullPath = fullPath.concat(tramo.path.slice(1));
          }
        }
      });

      // Calcular la distancia total de la nueva ruta
      let distanciaTotal = 0;
      for (let i = 0; i < fullPath.length - 1; i++) {
        distanciaTotal += this.calcularDistancia(fullPath[i], fullPath[i + 1]);
      }
      distanciaTotal = (distanciaTotal / 1000).toFixed(3); // Convertir a KM
      const payload = {
        tif_ruta_id: this.ruta.id,
        tramos_ids: tramos.map((t) => t.id),
        path: fullPath,
        distancia_km: parseFloat(distanciaTotal),
      };

      axios
        .post("/api/tif/rutas/saveRutasTramos", payload)
        .then((response) => {
          this.$parent.cargando = false;
          this.accion_ruta = false; // Desactivar el modo de edición
          this.$parent.init();
          this.obtenerRutasTramos(); // Recargar los tramos de la ruta

          this.$swal({
            icon: "success",
            title: "Cadena de tramos guardada exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.$parent.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
  beforeDestroy() {
    // Limpiar el timeout si el componente se destruye
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
  },
  mounted() {
    this.getIndex();
  },
};
</script>
